<template>
  <MapboxLayer
           v-bind:name="name"
           v-bind:beforeLayerName="beforeLayerName"
           v-bind:geoJSON="geoJSON"
           v-bind:layers="layers"
           v-bind:interactivity="interactivity"
           v-bind:clusterSettings="clusterSettings"
  />
  </template>
<script>
import MapboxLayer from './MapboxLayer'
import * as turf from 'turf'

export default {
  name: 'ArcRestLayer',
  components: { MapboxLayer },
  props: [
    'name',
    'beforeLayerName',
    'restURL',
    'layers',
    'interactivity',
    'clusterSettings',
  ],
  data: function () {
    return {
      geoJSON: {
        type: 'FeatureCollection',
        features: [],
      },
    }
  },
  computed: {
    map: function () {
      return this.$parent.map
    },
  },
  methods: {
    get_next(url, offset) {
      fetch(url + '&resultOffset=' + offset).then(r => r.json()).then(data => {
        if (url !== this.restURL) {
          // we are on an outdated chain of requests.
          return;
        }
        this.geoJSON = turf.featureCollection(this.geoJSON.features.concat(data.features))
        if (data.exceededTransferLimit) {
          this.get_next(url, this.geoJSON.features.length)
        }
      })
    },
  },
  watch: {
    restURL: {
      immediate: true,
      handler() {
        this.geoJSON=  {
        type: 'FeatureCollection',
        features: [],
      };
        this.get_next(this.restURL, 0)
      },
    },
  },
}
</script>

<style scoped>

</style>
